<template>
  <div class="bar-chart">
    <svg :width="width" :height="height">
      <g :style="{transform: `translate(0, ${margin.top}px)`}">
        <text v-for="(label, i) in labels" :key="i" :x="label.x" :y="label.y" text-anchor="end" style="font-size: 14px;">{{ label.label }}</text>
      </g>
      <g :style="{transform: `translate(${margin.left}px, ${margin.top}px)`}">
        <g :id="chartOptions.chartName + '__axis--x'" class="axis axis--x"></g>
        <rect v-for="(bar, i) in bars" :key="i" :fill="chartOptions.barColor ? chartOptions.barColor : '#cccccc'" :width="bar.width" :height="bar.height" :x="bar.x" :y="bar.y"></rect>
      </g>
    </svg>
  </div>
</template>

<script>
import * as d3 from 'd3';
import embeddable from '../mixins/embeddable'

const props = {
  chartData: Array,
  chartOptions: Object
};
export default {
  name: 'BarChart',
  mixins: [embeddable],
  props,
  data() {
    return {
      width: 0,
      height: 70 + (this.chartOptions.barHeight + this.chartOptions.barGap) * this.chartData.length,
    }
  },
  computed: {
    margin() {
      const left = this.chartOptions.labelWidth + 10,
      right = 0,
      top = 30,
      bottom = 40;
      return {left, right, top, bottom}
    },
    padded() {
      const width = this.width - this.margin.left - this.margin.right
      const height = this.height - this.margin.top - this.margin.bottom
      return {width, height}
    },
    scale() {
      const x = d3.scaleLinear()
        .domain([0, d3.max(this.chartData, d => d.value)])
        .range([0, this.padded.width]);
      return {x};
    },
    bars() {
      return this.chartData.map((d, i) => {
        return {
          width: Math.abs(this.scale.x(d.value)),
          height: Math.abs(this.chartOptions.barHeight),
          x: 0,
          y: (this.chartOptions.barHeight + this.chartOptions.barGap) * i
        }
      });
    },
    labels() {
      return this.chartData.map((d, i) => {
        return {
          label: d.label,
          x: this.chartOptions.labelWidth,
          y: 4 + (this.chartOptions.barHeight / 2) + (this.chartOptions.barHeight + this.chartOptions.barGap) * i
        }
      });
    }
  },
  mounted() {
    window.addEventListener('resize', this.onResize);
    this.onResize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.onResize);
  },
  watch: {
    width: function widthChanged() {
      this.initialize();
      this.update();
    }
  },
  methods: {
    onResize() {
      this.width = this.$el.offsetWidth;
    },
    initialize() {
      d3.axisBottom().scale(this.scale.x);
    },
    update() {
      const xAxis = d3.select("#" + this.chartOptions.chartName + "__axis--x")
        .call(d3.axisBottom(this.scale.x)
        .ticks(this.chartOptions.xAxisTicks)
        .tickFormat(this.chartOptions.xAxisTickFormat));

      xAxis.selectAll(".tick line").attr("y2", this.padded.height);
      xAxis.selectAll(".tick text").attr("transform", "translate(0, " + this.padded.height + ")")
    }
  }
}
</script>
